import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { Email, GitHub, Language } from '@mui/icons-material';

interface FooterProps {
  onTermsClick?: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onTermsClick }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0a0a0a',
        color: '#e0e0e0',
        borderTop: '2px solid #c0c0c0',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-around',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: 4,
            maxWidth: '800px',
            mx: 'auto',
          }}
        >
          {/* Company Info */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: '#c0c0c0' }}>
              Nina Software
            </Typography>
            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
              Professional Face Motion Capture Solutions
            </Typography>
          </Box>

          {/* Quick Links */}
          {/* <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: '#c0c0c0' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Link
                href="/docs"
                color="inherit"
                underline="hover"
                sx={{ color: '#b0b0b0', '&:hover': { color: '#c0c0c0' } }}
              >
                Documentation
              </Link>
              <Link
                href="/api"
                color="inherit"
                underline="hover"
                sx={{ color: '#b0b0b0', '&:hover': { color: '#c0c0c0' } }}
              >
                API Reference
              </Link>
              <Link
                href="/support"
                color="inherit"
                underline="hover"
                sx={{ color: '#b0b0b0', '&:hover': { color: '#c0c0c0' } }}
              >
                Support
              </Link>
            </Box>
          </Box> */}

          {/* Contact */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: '#c0c0c0' }}>
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                <Email fontSize="small" sx={{ color: '#c0c0c0' }} />
                <Link
                  href="mailto:comercial@ninasoftware.com"
                  color="inherit"
                  underline="hover"
                  sx={{ color: '#b0b0b0', '&:hover': { color: '#c0c0c0' } }}
                >
                  comercial@ninasoftware.com
                </Link>
              </Box>
              {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                <GitHub fontSize="small" sx={{ color: '#c0c0c0' }} />
                <Link
                  href="https://github.com/Nina-Software"
                  color="inherit"
                  underline="hover"
                  target="_blank"
                  sx={{ color: '#b0b0b0', '&:hover': { color: '#c0c0c0' } }}
                >
                  GitHub
                </Link>
              </Box> */}
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 3, backgroundColor: 'rgba(192,192,192,0.3)' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
            © {currentYear} Nina Software. All rights reserved.
          </Typography>
          <Box sx={{ mt: 1, mb: 1 }}>
            <Link
              href="/terms_conditions"
              onClick={event => {if (onTermsClick) {event.preventDefault();onTermsClick();}}}
              sx={{
                color: '#b0b0b0',
                cursor: 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  color: '#c0c0c0',
                  textDecoration: 'underline',
                },
              }}
            >
              Terms & Conditions
            </Link>
            <Link href="/privacy_policy" color="inherit" underline="hover" sx={{ml:3,color:"#b0b0b0"}}>Privacy Policy</Link>
            <Link href="/refund_policy" color="inherit" underline="hover" sx={{ml:3,color:"#b0b0b0"}}>Refund & Cancellation</Link>
          </Box>
          <Typography variant="caption" sx={{ color: '#808080', mt: 0.5, display: 'block' }}>
            Version 1.0.0 | Made with ❤️ for creators
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
